<template>
  <div class="flight-info mb-2">
    <div class="flight-box">
      <div class="d-flex justify-content-between font-weight-bold">
        <div class="">
          {{ flight.date | formatDateWithoutHours }}
        </div>

        <div class="">
          {{ flight.flightNo }}
        </div>

        <div class="">
          {{ flight.operator }}
        </div>

        <div class="">
          {{ flight.aircraftType }}
        </div>

        <div class="">
          {{ flight.aircraftRegistration }}
        </div>

        <div class="">
          {{ flight.departureAirport }}
        </div>

        <div class="">
          {{ flight.arrivalAirport }}
        </div>

        <div class="">
          {{ flight.scheduledTimeOfDeparture | formatTime}}
        </div>

        <div class="">
          {{ flight.scheduledTimeOfArrival | formatTime}}
        </div>

        <div class="">
          {{ flight.flightState }}
        </div>

        <div class="infobox-link cursor-pointer text-right pr-4" @v-on:click="openUrl(flight.url)">
          <i class="fas fa-link"></i>
          Infobox
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { FlightInfoDto } from '@/apiclient/apiclient_generated';
  import { Prop } from 'vue-property-decorator';

  @Component({})
  export default class FlightInfo extends Vue {
    @Prop() flight: FlightInfoDto;

    openUrl(url) {
      // if (event) {
      //   event.stopPropagation();
      // }
      window.open(url, '_blank');
    }
  }
</script>

<style scoped lang="scss">
  .flight-info {
    .flight-box {
      background: white;
      padding: 5px;
      border: 1px solid #ced4da;
      border-radius: 5px;
    }
  }
  .infobox-link:hover {
    text-decoration: underline;
  }
</style>
